import { render, staticRenderFns } from "./DietOverview.vue?vue&type=template&id=94577cd8&"
import script from "./DietOverview.vue?vue&type=script&lang=js&"
export * from "./DietOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports